export function setRedirectOnLogin(data){
    window.localStorage.setItem('redirect_on_login', JSON.stringify(data))
}

export function getRedirectOnLogin(){
    return JSON.parse(window.localStorage.getItem('redirect_on_login'));
}

export function removeRedirectOnLogin(){
    window.localStorage.removeItem('redirect_on_login')
}

export function downloadFile(data, filename){
    const href = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
}